(function () {
  "use strict";

  function productBestBuyButton() {
    const BUTTON_CLASS = "convx__redirecting-to-BestBuy";
    const BUTTON_TEXT = "You Can Order It On BestBuy If You're In the USA";
    const keychronURLs = [
      {
        variantId: "40026442235993",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-v1-75-custom-wired-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-translucent-black/6600172.p?skuId=6600172",
      },
      {
        variantId: "40637899669593",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-v1-max-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600175.p?skuId=6600175",
      },
      {
        variantId: "40759400005721",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-v5-max-96-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600170.p?skuId=6600170",
      },
      {
        variantId: "40617854435417",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q1he-75-custom-wireless-rgb-mechanical-keyboard-with-progrmmable-qmk-via-hot-swappable-magnetic-switch-black/6600174.p?skuId=6600174",
      },
      {
        variantId: "39951530950745",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q1-75-custom-wired-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-white/6600178.p?skuId=6600178",
      },
      {
        variantId: "40766137499737",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q3-max-80tkl-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600180.p?skuId=6600180",
      },
      {
        variantId: "40799763005529",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q6-max-100-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-black/6600176.p?skuId=6600176",
      },
      {
        variantId: "40799763038297",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-q6-max-100-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-banana-switch-black/6600171.p?skuId=6600171",
      },
      {
        variantId: "41846757883993",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k2-he-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-magnetic-switch-black/6600481.p?skuId=6600481",
      },
      {
        variantId: "41767492321369",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k2-max-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-brown-switch-black/6600173.p?skuId=6600173",
      },
      {
        variantId: "40685196968025",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k3-max-75-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600181.p?skuId=6600181",
      },
      {
        variantId: "40778479763545",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-k5-max-100-custom-wireless-rgb-mechanical-keyboard-with-programmable-qmk-via-hot-swappable-red-switch-black/6600169.p?skuId=6600169",
      },
      {
        variantId: "41293839138905",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-b1-pro-75-wireless-keyboard-with-progrmmable-zmk-support-space-gray/6600179.p?skuId=6600179",
      },
      {
        variantId: "41293896974425",
        redirectionURL:
          "https://www.bestbuy.com/site/keychron-b6-pro-100-custom-wireless-keyboard-with-progrmmable-zmk-support-space-grey/6600177.p?skuId=6600177",
      },
    ];

    const bestBuyByVariantId = new Map(
      keychronURLs.map((item) => [String(item.variantId), item.redirectionURL])
    );

    function createRedirectButton(redirectURL) {
      const button = document.createElement("a");
      button.href = redirectURL;
      button.target = "_blank";
      button.rel = "noopener noreferrer";
      button.textContent = BUTTON_TEXT;
      button.className = BUTTON_CLASS;
      return button;
    }

    function injectStyles() {
      if (document.getElementById("convx-bestbuy-button-styles")) return;

      const style = document.createElement("style");
      style.id = "convx-bestbuy-button-styles";
      style.textContent = `
          .${BUTTON_CLASS} {
            display: inline-block;
            border: var(--btn-border-width) solid rgb(var(--btn-alt-text-color));
            outline-color: rgb(var(--btn-alt-text-color));
            outline-offset: 3px;
            background: #0046be;
            color: white;
            margin-top: 15px;
            width: 100%;
            border-radius: var(--btn-border-radius, 0);
            padding: var(--btn-padding-y, 12px) 26px;
            text-align: center;
          }
          .${BUTTON_CLASS}:hover {
            background: #003bb5;
          }
        `;
      document.head.appendChild(style);
    }

    function getMainProductRoot() {
      return document.querySelector(".product.js-product");
    }

    function getAddToCartAnchor() {
      const scope = getMainProductRoot() || document;
      return (
        scope.querySelector(".product-info__add-to-cart") ||
        scope.querySelector('[data-pf-type="ProductATC2"]')?.parentElement ||
        scope.querySelector(".buy-now-form")?.parentElement
      );
    }

    function isMainProductVariantEvent(event) {
      const productRoot = getMainProductRoot();
      if (!productRoot) return false;

      const source =
        event.target instanceof Element
          ? event.target
          : event.detail?.form instanceof Element
            ? event.detail.form
            : null;

      return Boolean(source && productRoot.contains(source));
    }

    function getCurrentVariantID() {
      const productRoot = getMainProductRoot();
      if (!productRoot) return null;

      const picker = productRoot.querySelector("variant-picker");
      if (picker?.variant?.id) return String(picker.variant.id);

      const variantInput =
        productRoot.querySelector(
          '.js-product-form-main input[name="id"]:not([disabled])'
        ) ||
        productRoot.querySelector(
          '.js-product-form input[name="id"]:not([disabled])'
        ) ||
        productRoot.querySelector('.js-product-form-main input[name="id"]') ||
        productRoot.querySelector('.js-product-form input[name="id"]');
      if (variantInput?.value) return String(variantInput.value);

      const urlParams = new URLSearchParams(window.location.search);
      const variantFromQuery = urlParams.get("variant");
      if (variantFromQuery) return String(variantFromQuery);

      return null;
    }

    function removeRedirectButton() {
      document.querySelectorAll(`.${BUTTON_CLASS}`).forEach((el) => el.remove());
    }

    function addRedirectButton(variantID) {
      const redirectURL = variantID
        ? bestBuyByVariantId.get(String(variantID))
        : null;
      const existingButtons = document.querySelectorAll(`.${BUTTON_CLASS}`);
      const addToCartButton = getAddToCartAnchor();

      if (!redirectURL) {
        removeRedirectButton();
        return;
      }

      // ATC may be briefly missing during Sections API replace; retry via timeouts.
      if (!addToCartButton) return;

      let redirectButton = existingButtons[0] || null;
      existingButtons.forEach((el, index) => {
        if (index > 0) el.remove();
      });

      if (
        !redirectButton ||
        !addToCartButton.parentElement?.contains(redirectButton)
      ) {
        if (redirectButton) redirectButton.remove();
        redirectButton = createRedirectButton(redirectURL);
        addToCartButton.insertAdjacentElement("afterend", redirectButton);
        return;
      }

      redirectButton.href = redirectURL;
      redirectButton.textContent = BUTTON_TEXT;
    }

    function updateButtonFromVariantId(variantId) {
      if (variantId == null || variantId === "") {
        removeRedirectButton();
        return;
      }
      addRedirectButton(String(variantId));
    }

    function updateButtonFromDom() {
      addRedirectButton(getCurrentVariantID());
    }

    function scheduleButtonSync(callback) {
      setTimeout(callback, 0);
      setTimeout(callback, 50);
    }

    function observeVariantChange() {
      document.addEventListener("on:variant:change", (event) => {
        if (!isMainProductVariantEvent(event)) return;

        // Use event variant when present; clear button when selection is incomplete.
        const variantId = event.detail?.variant?.id ?? null;
        scheduleButtonSync(() => updateButtonFromVariantId(variantId));
      });

      // Legacy Swatch King fallback (app may still inject on some templates).
      document.addEventListener("click", (event) => {
        if (!event.target.closest(".swatch-view-item")) return;
        if (!getMainProductRoot()?.contains(event.target)) return;
        scheduleButtonSync(updateButtonFromDom);
      });

      updateButtonFromDom();
      setTimeout(updateButtonFromDom, 300);
    }

    function init() {
      injectStyles();
      observeVariantChange();
    }

    init();
  }

  function productWalmartButton() {
    const walmartURLs = [
      {
        productPath: "/products/keychron-b33-wireless-keyboard",
        redirectionURL:
          "https://www.walmart.com/ip/Keychron-B33-80-TKL-Wireless-Silent-Keyboard-2-4G-Bluetooth-Wired-for-MacOS-Windows-Linux-Black/17404822409",
      },
      {
        productPath: "/products/keychron-b36-wireless-keyboard",
        redirectionURL:
          "https://www.walmart.com/ip/Keychron-B36-Full-Size-100-Wireless-Silent-Keyboard-2-4G-Bluetooth-Wired-for-MacOS-Windows-Linux-Black/17449957056",
      },
      {
        productPath:
          "/products/keychron-c1-pro-qmk-via-wired-mechanical-keyboard",
        variantId: "43135199608921",
        redirectionURL:
          "https://www.walmart.com/ip/Keychron-C1-Pro-QMK-Wired-Custom-Mechanical-Keyboard-TKL-Layout-Launcher-Support-Super-Linear-Red-Switch-OSA-PBT-Keycaps-Compatible-Mac-Windows-Linux/19877915438",
      },
      {
        productPath:
          "/products/keychron-c2-pro-qmk-via-wired-mechanical-keyboard",
        variantId: "43135200002137",
        redirectionURL:
          "https://www.walmart.com/ip/Keychron-C2-Pro-Wired-Custom-Mechanical-Keyboard-Super-Linear-Red-Switch-Full-Size-RGB-Backlit-OSA-PBT-Double-Shot-Keycaps-Compatible-Mac-Windows-Lin/19896255081",
      },
    ];

    function createRedirectButton(redirectURL) {
      const button = document.createElement("a");
      button.href = redirectURL;
      button.target = "_blank";
      button.textContent = "You Can Order It On Walmart If You're in the USA";
      button.className = "convx__redirecting-to-Walmart";
      return button;
    }

    function injectStyles() {
      if (document.getElementById("convx-walmart-button-styles")) return;

      const style = document.createElement("style");
      style.id = "convx-walmart-button-styles";
      style.textContent = `
          .convx__redirecting-to-Walmart {
            display: inline-block;
            border: var(--btn-border-width) solid rgb(var(--btn-alt-text-color));
            outline-color: rgb(var(--btn-alt-text-color));
            outline-offset: 3px;
            background: #0064be;
            color: white;
            margin-top: 15px;
            width: 100%;
            border-radius: var(--btn-border-radius, 0);
            padding: var(--btn-padding-y, 12px) 26px;
            text-align: center;
          }
          .convx__redirecting-to-Walmart:hover {
            background: #0055a8;
          }
        `;
      document.head.appendChild(style);
    }

    function getCurrentVariantID() {
      const urlParams = new URLSearchParams(window.location.search);
      const variantFromQuery = urlParams.get("variant");
      if (variantFromQuery) return variantFromQuery;

      const variantInput =
        document.querySelector(
          '.js-product-form-main input[name="id"]:not([disabled])'
        ) ||
        document.querySelector('input[name="id"]:not([disabled])') ||
        document.querySelector('.js-product-form-main input[name="id"]') ||
        document.querySelector('input[name="id"]');
      if (variantInput?.value) return variantInput.value;

      const picker = document.querySelector("variant-picker");
      if (picker?.variant?.id) return String(picker.variant.id);

      return null;
    }

    function getAddToCartAnchor() {
      return (
        document.querySelector(".product-info__add-to-cart") ||
        document.querySelector('[data-pf-type="ProductATC2"]')?.parentElement ||
        document.querySelector(".buy-now-form")?.parentElement
      );
    }

    function getMatch() {
      const path = window.location.pathname;
      const currentVariantId = getCurrentVariantID();

      return walmartURLs.find((item) => {
        if (!path.endsWith(item.productPath)) return false;
        if (item.variantId) return currentVariantId === item.variantId;
        return true;
      });
    }

    function isWalmartProductPage() {
      const path = window.location.pathname;
      return walmartURLs.some((item) => path.endsWith(item.productPath));
    }

    function addRedirectButton(match) {
      const redirectButton = document.querySelector(
        ".convx__redirecting-to-Walmart"
      );
      const addToCartButton = getAddToCartAnchor();

      if (!addToCartButton) return;

      if (match) {
        if (!redirectButton) {
          addToCartButton.insertAdjacentElement(
            "afterend",
            createRedirectButton(match.redirectionURL)
          );
        } else {
          redirectButton.href = match.redirectionURL;
        }
      } else if (redirectButton) {
        redirectButton.remove();
      }
    }

    function updateButton() {
      addRedirectButton(getMatch());
    }

    function observeVariantChange() {
      document.addEventListener("on:variant:change", updateButton);

      document.addEventListener("click", (event) => {
        if (!event.target.closest(".swatch-view-item")) return;
        setTimeout(updateButton, 0);
      });

      updateButton();
      setTimeout(updateButton, 300);
    }

    function init() {
      if (!isWalmartProductPage()) return;

      injectStyles();
      observeVariantChange();
    }

    init();
  }

  function product_ratings() {
    // Select the product element
    const productElement = document.querySelector(".product.js-product");
    if (!productElement) {
      console.error("Product element '.product.js-product' not found.");
      return;
    }

    const ratingValue = parseFloat(productElement.dataset.ratingValue);
    const ratingCount = parseInt(productElement.dataset.ratingCount, 10);

    if (isNaN(ratingValue)) {
      // console.error("Invalid or missing 'data-rating-value'.");
      return;
    }

    // Calculate stars rating
    const decimal = ratingValue % 1;
    let starsRating = Math.floor(ratingValue);

    if (decimal >= 0.3 && decimal <= 0.7) {
      starsRating += 0.5;
    } else if (decimal > 0.7) {
      starsRating = Math.ceil(ratingValue);
    }

    const scaleMax = 5; // Assuming 5 as the maximum rating scale

    // Create the rating HTML
    const ratingHTML = `
        <div class="rating inline-block align-middle" role="img" 
          aria-label="${ratingValue} out of ${scaleMax} stars">
          <span class="rating__stars" aria-hidden="true" 
            style="--rating: ${starsRating}; --rating-max: ${scaleMax};">★★★★★</span>
        </div>
        ${
          !isNaN(ratingCount)
            ? `<div class="rating__count inline-block align-middle text-sm">(${ratingCount})</div>`
            : ""
        }
      `;

    // Select the product price element
    const productPrice = document.querySelector(".product-info__price");
    if (!productPrice) {
      console.error("Product price element '.product-info__price' not found.");
      return;
    }

    // Create a container for the rating and append it after .product-info__price
    const ratingContainer = document.createElement("div");
    ratingContainer.classList.add("product-rating");
    ratingContainer.innerHTML = ratingHTML;

    productPrice.insertAdjacentElement("afterend", ratingContainer);
    console.log("Rating element successfully appended.");
  }

  function addonsAccordion() {
    class ConvxAddonsAccordion extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initAccordion();
        this.initCheckboxListeners();
        this.bindVariantChangePreserve();
        this.openAllPanels();
        this.bindScrollConstraintObservers();
        this.syncScrollConstraint();
        // Re-measure after layout/images settle (natural height changes).
        requestAnimationFrame(() => this.syncScrollConstraint());
        setTimeout(() => this.syncScrollConstraint(), 150);
        setTimeout(() => this.syncScrollConstraint(), 500);
        this.querySelectorAll("img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener("load", this._onResizeSync, { once: true });
          }
        });
        if (document.readyState !== "complete") {
          window.addEventListener("load", this._onResizeSync, { once: true });
        }
      }

      isDesktopViewport() {
        return window.matchMedia("(min-width: 769px)").matches;
      }

      openAllPanels() {
        this.querySelectorAll(".convx__addons-accordion").forEach((button) => {
          const panel = button.nextElementSibling;
          if (!panel || !panel.classList.contains("convx__addons-panel")) return;
          button.classList.add("active");
          panel.style.maxHeight = `${Math.max(panel.scrollHeight, 1) + 100}px`;
          panel.style.paddingBottom = "15px";
        });
      }

      refreshOpenPanelHeights() {
        this.querySelectorAll(".convx__addons-accordion.active").forEach((button) => {
          const panel = button.nextElementSibling;
          if (!panel || !panel.classList.contains("convx__addons-panel")) return;
          panel.style.maxHeight = `${Math.max(panel.scrollHeight, 1) + 100}px`;
          panel.style.paddingBottom = panel.style.paddingBottom || "15px";
        });
      }

      getProductInfo() {
        return this.closest(".product-info");
      }

      getProductMedia() {
        const section = this.closest(".cc-main-product, .shopify-section");
        return (
          (section && section.querySelector("#product-media")) ||
          document.querySelector("#product-media")
        );
      }

      clearScrollConstraint() {
        // Legacy FBT-only constraint (remove if present from older builds).
        this.classList.remove("convx__addons--constrained");
        this.style.maxHeight = "";
        this.style.overflowY = "";

        const productInfo = this._kcConstrainedInfo || this.getProductInfo();
        if (productInfo) {
          this.unbindPageScrollChain(productInfo);
          productInfo.classList.remove("product-info--kc-scroll");
          productInfo.style.maxHeight = "";
          productInfo.style.height = "";
          productInfo.style.overflowY = "";
        }
        this._kcConstrainedInfo = null;
      }

      unbindPageScrollChain(productInfo) {
        if (!productInfo || !this._kcWheelChainHandler) return;
        productInfo.removeEventListener("wheel", this._kcWheelChainHandler);
      }

      bindPageScrollChain(productInfo) {
        if (!productInfo) return;
        if (!this._kcWheelChainHandler) {
          // At top/bottom of the right column, pass wheel delta to the page
          // so scrolling is not trapped inside product-info.
          this._kcWheelChainHandler = (event) => {
            const el = event.currentTarget;
            if (!el || !el.classList.contains("product-info--kc-scroll")) return;

            const delta = event.deltaY;
            if (!delta) return;

            const maxScroll = el.scrollHeight - el.clientHeight;
            const atTop = el.scrollTop <= 0;
            const atBottom = el.scrollTop >= maxScroll - 1;

            if (maxScroll <= 0 || (delta < 0 && atTop) || (delta > 0 && atBottom)) {
              event.preventDefault();
              window.scrollBy(0, delta);
            }
          };
        }
        this.unbindPageScrollChain(productInfo);
        productInfo.addEventListener("wheel", this._kcWheelChainHandler, {
          passive: false,
        });
      }

      bindScrollConstraintObservers() {
        if (this._kcScrollConstraintBound) return;
        this._kcScrollConstraintBound = true;

        this._onResizeSync = () => this.syncScrollConstraint();
        window.addEventListener("resize", this._onResizeSync);

        // Observe left gallery only — observing product-info would loop when
        // max-height changes. Panel open/toggle/variant already call sync.
        if (typeof ResizeObserver === "function") {
          const media = this.getProductMedia();
          if (media) {
            this._kcResizeObserver = new ResizeObserver(() => {
              this.syncScrollConstraint();
            });
            this._kcResizeObserver.observe(media);
          }
        }
      }

      syncScrollConstraint() {
        if (this._kcSyncingScroll) return;
        this._kcSyncingScroll = true;

        try {
          this.clearScrollConstraint();
          if (!this.isDesktopViewport()) return;

          const media = this.getProductMedia();
          const productInfo = this.getProductInfo();
          if (!media || !productInfo) return;

          this.refreshOpenPanelHeights();

          // Fixed height = left #product-media (橱窗) height; whole right
          // purchase column scrolls inside that height (desktop only).
          const mediaH = Math.floor(
            Math.max(
              media.offsetHeight || 0,
              media.getBoundingClientRect().height || 0
            )
          );
          if (mediaH <= 0) return;

          // Always apply the fixed height on desktop when FBT is present so
          // the right column matches the gallery and scrolls inside.
          this._kcConstrainedInfo = productInfo;
          productInfo.classList.add("product-info--kc-scroll");
          productInfo.style.height = `${mediaH}px`;
          productInfo.style.maxHeight = `${mediaH}px`;
          productInfo.style.overflowY = "auto";
          this.bindPageScrollChain(productInfo);
        } finally {
          requestAnimationFrame(() => {
            this._kcSyncingScroll = false;
          });
        }
      }

      bindVariantChangePreserve() {
        if (this._kcVariantPreserveBound) return;
        this._kcVariantPreserveBound = true;
        this._onVariantChangePreserve = () => this.preserveOpenPanels();
        document.addEventListener("on:variant:change", this._onVariantChangePreserve);
      }

      disconnectedCallback() {
        if (this._onVariantChangePreserve) {
          document.removeEventListener(
            "on:variant:change",
            this._onVariantChangePreserve
          );
        }
        if (this._onResizeSync) {
          window.removeEventListener("resize", this._onResizeSync);
        }
        if (this._kcResizeObserver) {
          this._kcResizeObserver.disconnect();
          this._kcResizeObserver = null;
        }
        this.clearScrollConstraint();
      }

      preserveOpenPanels() {
        this.querySelectorAll(".convx__addons-accordion.active").forEach((button) => {
          const panel = button.nextElementSibling;
          if (!panel || !panel.classList.contains("convx__addons-panel")) return;
          // Re-assert expanded height so option-list reflow above FBT cannot
          // collapse an open accordion for a frame (visible jump/flash).
          panel.style.maxHeight = `${Math.max(panel.scrollHeight, 1) + 100}px`;
          panel.style.paddingBottom = panel.style.paddingBottom || "15px";
        });
        this.syncScrollConstraint();
      }

      initAccordion() {
        const buttons = this.querySelectorAll(".convx__addons-accordion");

        buttons.forEach((button) => {
          if (button.dataset.kcAccordionBound === "true") return;
          button.dataset.kcAccordionBound = "true";

          button.addEventListener("click", () => {
            const panel = button.nextElementSibling;
            if (!panel || !panel.classList.contains("convx__addons-panel")) return;
            const isOpen = button.classList.contains("active");

            if (isOpen) {
              button.classList.remove("active");
              panel.style.maxHeight = null;
              panel.style.paddingBottom = null;
            } else {
              button.classList.add("active");
              panel.style.maxHeight = panel.scrollHeight + 100 + "px";
              panel.style.paddingBottom = 15 + "px";
            }

            this.syncScrollConstraint();
          });
        });
      }
      initCheckboxListeners() {
        const checkboxes = this.querySelectorAll(
          ".addons-option input[type='checkbox']"
        );
        checkboxes.forEach((checkbox) => {
          checkbox.addEventListener("change", () => {
            const parentLabel = checkbox.closest(".addons-option");
            const quantityInput = parentLabel.querySelector(
              "input[type='hidden']"
            );

            if (checkbox.checked) {
              parentLabel.classList.add("active");
              quantityInput.disabled = false;
            } else {
              parentLabel.classList.remove("active");
              quantityInput.disabled = true;
            }
          });
        });
      }
      getCheckedValues() {
        const checkedValues = [];
        this.querySelectorAll("input[type='checkbox']:checked").forEach(
          (input) => {
            checkedValues.push(input.value);
          }
        );
        return checkedValues;
      }
    }

    window.customElements.define("convx-addons", ConvxAddonsAccordion);
  }

  function productSamsClubButton() {
    console.log("Sam's Club running");

    function createRedirectButton() {
      const button = document.createElement("a");
      button.href =
        "https://www.samsclub.com/p/keychron-k2he-elite-bundle/P990411626?xid=plp_product_1";
      button.target = "_blank";
      button.textContent = "You Can Order It On Sam's Club If You're In USA";
      button.className = "convx__redirecting-to-samsclub";
      return button;
    }

    function injectStyles() {
      const style = document.createElement("style");
      style.textContent = `
          .convx__redirecting-to-samsclub {
            display: inline-block;
            border: var(--btn-border-width) solid rgb(var(--btn-alt-text-color));
            outline-color: rgb(var(--btn-alt-text-color));
            outline-offset: 3px;
            background: #2D659E;
            color: white;
            margin-top: 15px;
            width: 100%;
            border-radius: var(--btn-border-radius, 0);
            padding: var(--btn-padding-y, 12px) 26px;
            text-align: center;
          }
          .convx__redirecting-to-samsclub:hover {
            background: #367AAE;
          }
        `;
      document.head.appendChild(style);
    }

    function addRedirectButton() {
      let redirectButton = document.querySelector(
        ".convx__redirecting-to-samsclub"
      );
      const addToCartButton = document.querySelector(
        ".product-info__add-to-cart"
      );
      if (addToCartButton) {
        if (!redirectButton) {
          // Create a new button if it doesn't exist
          redirectButton = createRedirectButton();
          addToCartButton.insertAdjacentElement("afterend", redirectButton);
        }
      }
    }

    function init() {
      if (
        window.location.href.indexOf(
          "/products/keychron-k2-he-keyboard-and-m3-lite-mouse-wireless-elite-bundle"
        ) > -1
      ) {
        injectStyles();
        addRedirectButton();
      }
    }

    init();
  }

  function convxAccordion() {
    class ConvxAccordion extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.initAccordion();
      }

      initAccordion() {
        const buttons = this.querySelectorAll(".convx__addons-accordion");

        buttons.forEach((button) => {
          button.addEventListener("click", () => {
            const panel = button.nextElementSibling;
            const isOpen = button.classList.contains("active");

            // Close all panels
            // this.querySelectorAll(".convx__addons-accordion").forEach((btn) => {
            //   btn.classList.remove("active");
            //   btn.nextElementSibling.style.maxHeight = null;
            //   btn.nextElementSibling.style.paddingBottom = null;
            // });

            // if (!isOpen) {
            //   button.classList.add("active");
            //   panel.style.maxHeight = panel.scrollHeight + 15 + "px";
            //   panel.style.paddingBottom = 15 + "px";
            // }

            if (isOpen) {
              button.classList.remove("active");
              panel.style.maxHeight = null;
              panel.style.paddingBottom = null;
            } else {
              button.classList.add("active");
              panel.style.maxHeight = panel.scrollHeight + 100 + "px";
              panel.style.paddingBottom = 48 + "px";
            }
          });
        });
      }
    }

    window.customElements.define("convx-accordion", ConvxAccordion);
  }

  function headerSpacing() {
    const header = document.querySelector("store-header.header");
    if (!header) return;

    const updateHeaderSpacing = () => {
      const rect = header.getBoundingClientRect();
      const topOffset = rect.top; // Distance from top of screen
      const height = rect.height;
      const totalSpacing = topOffset + height;

      document.documentElement.style.setProperty(
        "--convx-header-spacing",
        `${totalSpacing}px`
      );

      document.documentElement.style.setProperty(
        "--convx-header-without-announcement-spacing",
        `${height}px`
      );

      document.documentElement.style.setProperty(
        "--convx-header-announcement-spacing",
        `${topOffset}px`
      );
    };

    // Observe size changes
    const resizeObserver = new ResizeObserver(updateHeaderSpacing);
    resizeObserver.observe(header);

    // Also recalculate on scroll (if sticky/fixed or dynamic layout)
    window.addEventListener("scroll", updateHeaderSpacing);
    window.addEventListener("resize", updateHeaderSpacing);
    window.addEventListener("load", updateHeaderSpacing);
  }

function horizontalScroll() {
    // Horizontal Scroll Component
    class ConvxHorizontalScroll extends HTMLElement {
      constructor() {
        super();
        this.scrollTriggerInstance = null;
        this.observer = null;
      }

      connectedCallback() {
        this.initHorizontalScroll();

        // Watch for page height changes with throttling
        this.observer = new ResizeObserver(entries => {
          if (window.innerWidth <= 768) return; // Skip on mobile
          
          clearTimeout(this._refreshTimeout);
          this._refreshTimeout = setTimeout(() => {
            // Only refresh if we're in desktop mode and have ScrollTrigger instances
            if (this.scrollTriggerInstance && window.innerWidth > 768) {
              requestAnimationFrame(() => {
                ScrollTrigger.refresh();
              });
            }
          }, 200);
        });

        this.observer.observe(document.body);

        // Set mobile properties from attributes
        const mobileHeight = this.getAttribute('mobile-height');
        const mobileSpacing = this.getAttribute('mobile-spacing');
        
        this.style.setProperty('--mobile-height', `${mobileHeight}px`);
        this.style.setProperty('--mobile-spacing', `${mobileSpacing}px`);
      }

      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
        if (this.scrollTriggerInstance) {
          this.scrollTriggerInstance.kill();
        }
      }

      initHorizontalScroll() {
        if (window.innerWidth <= 768) return;

        const container = this.querySelector('.convx-horizontal-scroll__container');
        const sections = Array.from(this.querySelectorAll('.convx-horizontal-scroll__section'));
        
        if (!container || sections.length < 2) return;

        // Set container width based on number of sections
        container.style.width = `${sections.length * 100}vw`;

        // Kill previous instance if it exists
        if (this.scrollTriggerInstance) {
          this.scrollTriggerInstance.kill();
        }

        gsap.registerPlugin(ScrollTrigger);
        
        // Create animation timeline for smoother performance
        const tl = gsap.timeline();
        tl.to(sections, {
          xPercent: -100 * (sections.length - 1),
          ease: "none"
        });
        
        this.scrollTriggerInstance = ScrollTrigger.create({
          trigger: this.querySelector('.convx-horizontal-scroll__wrapper'),
          pin: true,
          pinSpacing: true,
          start: "top top",
          end: () => `+=${container.offsetWidth - window.innerWidth}`,
          scrub: 0, // Smoother scrub value
          // snap: {
          //   snapTo: 1 / (sections.length - 1),
          //   duration: 0.3,
          //   delay: 0.1
          // },
          markers: false,
          anticipatePin: 1,
          refreshPriority: -1,
          animation: tl,
          onRefresh: () => {
            // Ensure proper dimensions on refresh
            container.style.width = `${sections.length * 100}vw`;
          },
          onToggle: self => {
            // Prevent glitching during pin/unpin
            if (self.isActive) {
              gsap.set(this.querySelector('.convx-horizontal-scroll__wrapper'), { willChange: "transform" });
            } else {
              gsap.set(this.querySelector('.convx-horizontal-scroll__wrapper'), { willChange: "auto" });
            }
          }
        });

        // Handle resize with debouncing and proper cleanup
        this._handleResize = () => {
          clearTimeout(this._resizeTimeout);
          this._resizeTimeout = setTimeout(() => {
            const currentWidth = window.innerWidth;
            
            // Only reload on mobile/desktop breakpoint changes
            if ((currentWidth <= 768 && this._lastWidth > 768) ||
                (currentWidth > 768 && this._lastWidth <= 768)) {
              window.location.reload();
              return;
            }
            
            // For desktop resizes, refresh ScrollTrigger
            if (currentWidth > 768) {
              // Update container width first
              container.style.width = `${sections.length * 100}vw`;
              
              // Batch DOM reads/writes
              requestAnimationFrame(() => {
                ScrollTrigger.refresh();
              });
            }
            
            this._lastWidth = currentWidth;
          }, 150); // Reduced timeout for better responsiveness
        };

        window.addEventListener('resize', this._handleResize, { passive: true });
        this._lastWidth = window.innerWidth;
      }
    }

    // Register the custom element
    customElements.define('convx-horizontal-scroll', ConvxHorizontalScroll);
  }



  // Collection Toggle Filter

    function debounce(fn, wait = 120) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), wait);
    };
  }

  let activeFilterName = null;

  function getFilterInputs() {
    if (!activeFilterName) return [];
    return Array.from(
      document.querySelectorAll(`input[type="checkbox"][name="${activeFilterName}"]`)
    );
  }

  function ensureStyle() {
    if (document.getElementById("convx-collection-toggle-style")) return;
    const style = document.createElement("style");
    style.id = "convx-collection-toggle-style";
    style.textContent = `
      .convx__collection-toggle-container {
        margin-top: 10px;
        overflow: hidden;
        flex-basis: 100%;
        position: relative;
      }

      .convx__toggle-scroller {
        display: flex;
        gap: 6px;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        -webkit-overflow-scrolling: touch;
        padding-bottom: 8px;
        scrollbar-width: none;
        -ms-overflow-style: none;
        scroll-behavior: smooth;
        position: relative;
      }
      .convx__toggle-scroller::-webkit-scrollbar {
        display: none;
      }

      .convx__collection-toggle-container::after,
      .convx__collection-toggle-container::before {
        content: "";
        position: absolute;
        top: 0;
        width: 40px;
        height: 100%;
        pointer-events: none;
        z-index: 1;
        transition: opacity 0.2s ease;
      }
      .convx__collection-toggle-container::after {
        right: 0;
        background: linear-gradient(to right, transparent, rgba(255,255,255,0.9));
      }
      .convx__collection-toggle-container::before {
        left: 0;
        background: linear-gradient(to left, transparent, rgba(255,255,255,0.9));
        opacity: 0;
      }

      .convx__toggle-btn {
        flex: 0 0 auto;
        scroll-snap-align: start;
        border: 1px solid #000;
        background: #fff;
        color: #000;
        padding: 8px 12px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.2s ease;
        min-width: 60px;
        white-space: nowrap;
      }
      .convx__toggle-btn.active {
        background: #000;
        color: #fff;
      }

      .products-toolbar { flex-wrap: wrap; }

      .convx__scroll-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        border: none;
        background: rgba(255,255,255,0.9);
        box-shadow: 0 2px 6px rgba(0,0,0,0.2);
        border-radius: 50%;
        width: 32px;
        height: 32px;
        cursor: pointer;
        z-index: 2;
        display: none;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s ease, background 0.2s ease;
      }

      @media (min-width: 768px) {
        .convx__scroll-btn { display: flex; }
      }

      .convx__scroll-btn:hover { background: #fff; }
      .convx__scroll-btn.left { left: 4px; }
      .convx__scroll-btn.right { right: 4px; }
      .convx__scroll-btn.hidden { opacity: 0; pointer-events: none; }
    `;
    document.head.appendChild(style);
  }

  function getLabelTextForCheckbox(checkbox) {
    const label = checkbox.closest("label") || checkbox.nextElementSibling;
    const span = label?.querySelector("span");
    return (span?.innerText || label?.innerText || checkbox.value || "").trim();
  }

  let lastScrollLeft = 0;
  let ignoreScrollMemory = false;

  function createOrUpdateToggleUI() {
    const oldContainer = document.querySelector(".convx__collection-toggle-container");
    if (oldContainer) oldContainer.remove();

    if (!window.location.pathname.includes("/collections/") || window.location.pathname.includes("/products/"))
      return;

    ensureStyle();

    let checkboxes = Array.from(
      document.querySelectorAll('input[type="checkbox"][name="filter.p.m.convx.keyboard_layout_size"]')
    );
    activeFilterName = "filter.p.m.convx.keyboard_layout_size";

    if (!checkboxes.length) {
      checkboxes = Array.from(
        document.querySelectorAll('input[type="checkbox"][name="filter.p.m.convx.keycap_standard"]')
      );
      activeFilterName = "filter.p.m.convx.keycap_standard";
    }

    // if there is only one checkbox, then don't show the toggle filter
    if (checkboxes.length === 1) {
      return;
    }

    if (!checkboxes.length) return;

    const container = document.createElement("div");
    container.className = "convx__collection-toggle-container";

    const leftBtn = document.createElement("button");
    leftBtn.className = "convx__scroll-btn left hidden";
    leftBtn.innerHTML = "&#10094;";

    const rightBtn = document.createElement("button");
    rightBtn.className = "convx__scroll-btn right hidden";
    rightBtn.innerHTML = "&#10095;";

    const scroller = document.createElement("div");
    scroller.className = "convx__toggle-scroller";

    container.append(leftBtn, scroller, rightBtn);

    checkboxes.forEach((checkbox, i) => {
      const labelText = getLabelTextForCheckbox(checkbox) || `Option ${i + 1}`;
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "convx__toggle-btn";
      btn.innerText = labelText;
      btn.dataset.index = String(i);
      btn.dataset.label = labelText;

      if (checkbox.checked) btn.classList.add("active");

      btn.addEventListener("click", () => {
        const liveCheckbox = findLiveCheckboxForButton(btn);
        if (!liveCheckbox) return;
        const wasChecked = liveCheckbox.checked;
        ignoreScrollMemory = true; // prevent visual jump
        liveCheckbox.click();
        btn.classList.toggle("active", !wasChecked);
        setTimeout(() => {
          ignoreScrollMemory = false;
          syncAllButtons();
        }, 180);
      });

      scroller.appendChild(btn);
    });

    const toolbar = document.querySelector("products-toolbar");
    if (toolbar) toolbar.append(container);
    else (document.querySelector("[role='main']") || document.body).prepend(container);

    const scrollAmount = 150;
    leftBtn.addEventListener("click", () =>
      scroller.scrollBy({ left: -scrollAmount, behavior: "smooth" })
    );
    rightBtn.addEventListener("click", () =>
      scroller.scrollBy({ left: scrollAmount, behavior: "smooth" })
    );

    function updateScrollButtons() {
      const maxScroll = scroller.scrollWidth - scroller.clientWidth;
      leftBtn.classList.toggle("hidden", scroller.scrollLeft <= 5);
      rightBtn.classList.toggle("hidden", scroller.scrollLeft >= maxScroll - 5);
      container.style.setProperty("--fade-opacity", scroller.scrollLeft > 5 ? "1" : "0");
      if (!ignoreScrollMemory) lastScrollLeft = scroller.scrollLeft;
    }

    scroller.addEventListener("scroll", debounce(updateScrollButtons, 60));
    setTimeout(() => {
      scroller.scrollLeft = lastScrollLeft; // restore previous position quietly
      updateScrollButtons();
    }, 200);

    // Sync logic
    function findLiveCheckboxForButton(button) {
      const labelText = (button.dataset.label || "").trim();
      const idx = parseInt(button.dataset.index, 10);
      const inputs = getFilterInputs();
      const match = inputs.find((cb) => getLabelTextForCheckbox(cb) === labelText);
      return match || inputs[idx] || null;
    }

    function syncAllButtons() {
      const buttons = document.querySelectorAll(".convx__toggle-btn");
      buttons.forEach((btn) => {
        const live = findLiveCheckboxForButton(btn);
        btn.classList.toggle("active", !!(live && live.checked));
      });
    }

    document.addEventListener("change", (e) => {
      if (!e.target.matches(`input[type="checkbox"][name="${activeFilterName}"]`)) return;
      debounce(syncAllButtons, 80)();
    });

    const observeRoot = checkboxes[0].closest("form") || checkboxes[0].closest(".filters") || document.body;
    const mo = new MutationObserver(
      debounce(() => {
        const newBoxes = Array.from(
          document.querySelectorAll(`input[type="checkbox"][name="${activeFilterName}"]`)
        );
        if (!newBoxes.length) return;
        if (newBoxes.length !== checkboxes.length || newBoxes[0] !== checkboxes[0]) {
          mo.disconnect();
          createOrUpdateToggleUI();
          return;
        }
        syncAllButtons();
      }, 150)
    );
    mo.observe(observeRoot, { childList: true, subtree: true, attributes: true });
  }

  function collectionToggleFilterInit() {
    const path = location.pathname;
    if (path.includes("/collections") && !path.includes("/products")) createOrUpdateToggleUI();
  }


  function onDOMContentLoaded() {
    const path = location.pathname;
    const isHomePage = path == "/";
    const isProducts = path.includes("/products");
    const isCollections = path.includes("/collections") && !isProducts;
    const isCart = path == "/cart";

    headerSpacing();
    addonsAccordion();
    horizontalScroll();

    if (isProducts) {
      product_ratings();
      // BestBuy / Walmart redirect buttons temporarily disabled
      // productBestBuyButton();
      // productWalmartButton();
      productSamsClubButton();
    }
    convxAccordion();

    if (isCollections) {
      collectionToggleFilterInit();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onDOMContentLoaded, {
      once: true,
    });
  } else {
    onDOMContentLoaded();
  }
})();


// Pin disclaimer only within horizontal scroll on desktop
function pinDisclaimerWithinHorizontalScroll() {
  const disclaimer = document.querySelector('.convx__pin-disclaimer');
  const scrollWrapper = document.querySelector('.convx-horizontal-scroll__wrapper');
  if (!disclaimer || !scrollWrapper) return;

  function checkPinVisibility() {
    if (window.innerWidth <= 768) {
      disclaimer.classList.remove('is-hidden');
      return;
    }
    const rect = scrollWrapper.getBoundingClientRect();
    // Show only when the horizontal scroll is in view
    if (rect.bottom > 0 && rect.top < window.innerHeight) {
      disclaimer.classList.remove('is-hidden');
    } else {
      disclaimer.classList.add('is-hidden');
    }
  }

  window.addEventListener('scroll', checkPinVisibility, { passive: true });
  window.addEventListener('resize', checkPinVisibility, { passive: true });
  checkPinVisibility();
}

document.addEventListener('DOMContentLoaded', () => {
  pinDisclaimerWithinHorizontalScroll();
});